import React from 'react'
import Feature from './Feature'
import { s } from '../style'
import { useLangContext } from '../context/lang.context'

import boxes from '../assets/features/boxes.svg'
import document from '../assets/features/document.svg'
import dollar from '../assets/features/dollar.svg'
import dollar_trade from '../assets/features/dollar_trade.svg'
import server from '../assets/features/server.svg'
import settings from '../assets/features/settings.svg'
import settings_trade from '../assets/features/settings_trade.svg'
import time from '../assets/features/time.svg'
import time_trade from '../assets/features/time_trade.svg'
import truck from '../assets/features/truck.svg'
import unload from '../assets/features/unload.svg'
import unknown from '../assets/features/dollar.svg'
import eco from '../assets/features/eco.svg'
import shield from '../assets/features/shield.svg'
import hammer from '../assets/features/hammer.svg'

import career1 from '../assets/career/career1.svg'
import career2 from '../assets/career/career2.svg'
import career3 from '../assets/career/career3.svg'
import career4 from '../assets/career/career4.svg'
import career5 from '../assets/career/career5.svg'
import career6 from '../assets/career/career6.svg'

import przewoznik1 from '../assets/przewoznik/przewoznik1.svg'
import przewoznik2 from '../assets/przewoznik/przewoznik2.svg'
import przewoznik3 from '../assets/przewoznik/przewoznik3.svg'
import przewoznik4 from '../assets/przewoznik/przewoznik4.svg'
import przewoznik5 from '../assets/przewoznik/przewoznik5.svg'
import przewoznik6 from '../assets/przewoznik/przewoznik6.svg'
import przewoznik7 from '../assets/przewoznik/przewoznik7.svg'
import przewoznik8 from '../assets/przewoznik/przewoznik8.svg'

const icons = {
  boxes,
  truck,
  document,
  time,
  time_trade,
  dollar,
  dollar_trade,
  unload,
  settings,
  settings_trade,
  server,
  eco,
  shield,
  hammer,
  unknown,
  career1,
  career2,
  career3,
  career4,
  career5,
  career6,
  przewoznik1,
  przewoznik2,
  przewoznik3,
  przewoznik4,
  przewoznik5,
  przewoznik6,
  przewoznik7,
  przewoznik8,
}

const Features = ({ features, outerCss, noDesktop }) => {
  const { lang } = useLangContext()
  return (
    <div
      css={[
        sContainer,
        outerCss,
        noDesktop && { [s.md]: { display: 'none' } },
      ]}>
      {features?.map(({ title, subtitle, desc, icon }, id) => (
        <Feature
          key={id}
          title={title[lang]}
          subtitle={subtitle[lang]}
          desc={desc[lang]}
          icon={icons[icon] || unknown}
          count={features.length}
        />
      ))}
    </div>
  )
}

const sContainer = {
  flexWrap: 'wrap',
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  maxWidth: 1600 - 32,
  padding: '0 2rem 4rem',
  margin: '0 auto',
  [s.sm_down]: {
    width: '100% !important',
  },
  [s.xs]: {
    padding: '0 2rem',
  },
}
export default Features
